import React from "react";
import { Popover } from "../../../BP2Components";
import "./mapComponent.less";
import "../list.less";

const ListEditableRow = ({ record, cancel, save, edit }) => {
   return (
      <div
         className="editable-row-operations"
         style={{
            padding: "0px 10px",
            wordWrap: "break-word",
            wordBreak: "break-word"
         }}
      >
         {record.editable ? (
            <span>
               <Popover placement="left" content={"Cancel"} style={{ fontSize: "8px" }}>
                  <span
                     className="span-style icon icon-close"
                     style={{
                        fontSize: "23px"
                     }}
                     onClick={() => cancel(record.key)}
                  ></span>
               </Popover>
               <Popover placement="left" content={"Save"} style={{ fontSize: "8px" }}>
                  <div>
                     <span
                        className="span-style icon icon-check p1"
                        style={{
                           position: "relative",
                           left: "3px"
                        }}
                        onClick={() => save(record.key)}
                     ></span>
                  </div>
               </Popover>
            </span>
         ) : (
            <Popover content={"Edit"} style={{ fontSize: "8px" }}>
               <span className="span-style icon icon-edit" onClick={() => edit(record.key)}></span>
            </Popover>
         )}
      </div>
   );
};

export default ListEditableRow;
